var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-wrapper"},[_c('MyHeader'),_c('router-view'),_c('MyFooter',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }